import { render, staticRenderFns } from "./ChallengeResourcePackage.vue?vue&type=template&id=2c669c90&scoped=true"
import script from "./ChallengeResourcePackage.vue?vue&type=script&lang=js"
export * from "./ChallengeResourcePackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c669c90",
  null
  
)

export default component.exports